import {Button, Slider, Stack} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SubtractIcon from "@mui/icons-material/Remove";
import React, {memo} from "react";

export interface Props {
    zoom: number;
    onZoomChange: (value: number) => void;
}

// eslint-disable-next-line react/display-name
export const MapSlider: React.FC<Props> = memo(({zoom, onZoomChange}) => {
    return (
        <Stack direction="column" width="2rem" alignItems="center">
            <Button
                variant="contained"
                color="secondary"
                onClick={() => zoom < 22 && onZoomChange(zoom + 1)}
                startIcon={<AddIcon />}
                sx={{
                    width: "2rem",
                    height: "2rem",
                    "& .MuiButton-startIcon": {margin: 0},
                    minWidth: 0,
                    padding: "0.5rem",
                    borderTopRightRadius: 0,
                    borderTopLeftRadius: 0,
                    borderBottomRightRadius: "0.6rem",
                    borderBottomLeftRadius: "0.6rem",
                    zIndex: 10,
                }}
            />
            <Slider
                orientation="vertical"
                value={zoom}
                onChange={(_, value) => onZoomChange(value as number)}
                sx={{
                    height: "10rem",
                    "& .MuiSlider-thumb": {
                        width: "1.5rem",
                        height: "1.5rem",
                        backgroundColor: "#5161C1",
                        border: 3,
                        color: "#FFFFFF",
                        zIndex: 20,
                    },
                    "& .MuiSlider-rail": {
                        color: "#ACB0C0",
                        width: "0.6rem",
                        borderRadius: 0,
                        opacity: 1,
                    },
                    "& .MuiSlider-mark": {
                        width: "0.6rem",
                        color: "#CACDD8",
                        height: "1px",
                    },
                }}
                min={0}
                max={22}
                marks
                step={2}
                track={false}
            />
            <Button
                variant="contained"
                color="secondary"
                onClick={() => zoom > 0 && onZoomChange(zoom - 1)}
                startIcon={<SubtractIcon />}
                sx={{
                    width: "2rem",
                    height: "2rem",
                    "& .MuiButton-startIcon": {margin: 0},
                    minWidth: 0,
                    padding: "0.5rem",
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                    borderTopRightRadius: "0.6rem",
                    borderTopLeftRadius: "0.6rem",
                    zIndex: 10,
                }}
            />
        </Stack>
    );
});
